/* eslint react/prop-types: 0 */
import styled from '@emotion/styled';
import { useTranslation } from '@hotjar/translations';
import { IconButton, Stack, tokens } from '@hotjar/hotsauce';
import { LabeledField } from './LabeledField';

const StyledStack = styled(Stack)`
  align-items: center;
`;

const StyledIconButton = styled(IconButton)`
  background: ${(props) => (props.isActive ? tokens.color.bg_active : tokens.color.white)};
`;

export const Answer = ({
  commentEnabled,
  counter,
  hasError,
  onCommentClick,
  onDeleteClick,
  onTextChange,
  showDelete,
  text,
  rtl,
}) => {
  const { t } = useTranslation('feedback', { keyPrefix: 'wizard.section.questions.answer' });
  return (
    <StyledStack spacing="x1">
      <LabeledField
        counter={counter}
        hasError={hasError}
        label={t('label')}
        name="answer"
        value={text}
        onChange={onTextChange}
        placeholder={t('placeholder')}
        rtl={rtl}
      />
      <StyledStack spacing="x1">
        <StyledIconButton
          isActive={commentEnabled}
          size="s"
          icon="comment"
          onClick={onCommentClick}
          kind={commentEnabled ? 'secondary' : 'ghost'}
          tooltipText={
            commentEnabled ? t('comments-enabled-tooltip') : t('comments-disabled-tooltip')
          }
          description={commentEnabled ? t('disable-comment') : t('enable-comment')}
        />
        {showDelete && (
          <IconButton
            size="s"
            icon="trash"
            description={t('delete-answer')}
            tooltipText={t('delete-answer')}
            kind="ghost"
            onClick={onDeleteClick}
          />
        )}
      </StyledStack>
    </StyledStack>
  );
};
